import React from 'react';

import { Box, Typography } from '@mui/material';
import CheckboxCDS from '@sharedCR/coreDesignSystem/form/CheckboxCDS';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import StatusIconCDS from '@sharedCR/coreDesignSystem/StatusIconCDS';

import { StatusEnum } from 'constants/status';
import { getValueOrDash } from 'utils/data';
import { formatDateValue } from 'utils/format';

import { DRAW_CHECKLIST_COLUMN_KEY } from '../../DrawReviewDrawer.constants';
import { overrideCellStyles, resultCellStyles } from '../../DrawReviewDrawer.styles';
import { DrawReviewDrawerTestIds } from '../../DrawReviewDrawer.testIds';

import { checklistNoteStyles, itemNameCellStyles } from './DrawChecklistSection.styles';

const KEY = DRAW_CHECKLIST_COLUMN_KEY;

const renderResult = row => {
  const statusType = row.statusType ?? StatusEnum.SUCCESS;

  if (statusType === StatusEnum.SUCCESS) {
    return (
      <Box sx={resultCellStyles}>
        <StatusIconCDS type={StatusEnum.SUCCESS} />
        <Typography color="success.main" variant="medium14">
          {row.result}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={resultCellStyles}>
      <StatusIconCDS type={statusType} />
      <LabelCDS size={LabelSize.S} title={row.result} variant={LabelVariant.ORANGE} />
    </Box>
  );
};

const renderOverride = row => {
  if (!row.override) {
    return (
      <Typography color="text.secondary" variant="regular14">
        —
      </Typography>
    );
  }

  return (
    <Box sx={resultCellStyles}>
      <CheckboxCDS
        checked
        disabled
        dataTestId={DrawReviewDrawerTestIds.CHECKLIST_OVERRIDE_CHECKBOX}
      />
      <Box sx={overrideCellStyles}>
        <Typography variant="regular14">{row.override.by}</Typography>
        <Typography color="text.secondary" variant="regular12">
          {getValueOrDash(formatDateValue(row.override.at))}
        </Typography>
      </Box>
    </Box>
  );
};

export const getChecklistConfig = () => ({
  [KEY.ITEM_NAME]: {
    label: 'Item Name',
    align: 'left',
    content: row => (
      <Box sx={itemNameCellStyles}>
        <Typography variant="regular14">{row.name}</Typography>
        {row.note && (
          <Typography sx={checklistNoteStyles} variant="regular12">
            {row.note}
          </Typography>
        )}
      </Box>
    ),
  },
  [KEY.DETERMINATION]: {
    label: 'Determination',
    align: 'left',
    content: row => <Typography variant="regular14">{row.determination}</Typography>,
  },
  [KEY.RESULT]: {
    label: 'Result',
    align: 'left',
    content: renderResult,
  },
  [KEY.OVERRIDE]: {
    label: 'Override',
    align: 'left',
    content: renderOverride,
  },
});
